import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faArrowDown } from '@fortawesome/pro-solid-svg-icons'

import {
  AreaChart, Box, DashboardModule, Text,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useChartData, { calculatePercentageChange } from '@hooks/useChartData'

interface StatisticWithGraphProps {
  datePeriod: string,
  description: string,
  teamId: number,
}

const StatisticWithGraph = (props: StatisticWithGraphProps) => {
  const { datePeriod, description, teamId } = props

  const chartDataPayload = useChartData('task_list_items_completed_per_date_period', {
    requestOptions: { date_period: datePeriod, date_range: '3_months', team_id: teamId },
  })
  const { dataArray, loading } = chartDataPayload

  const dataForLatestPeriod = dataArray.slice(-1)[0]
  const dataForPreviousPeriod = dataArray.slice(-2, -1)[0]

  const percentageChange = calculatePercentageChange({
    currentData: dataForLatestPeriod,
    previousData: dataForPreviousPeriod,
    selectedDataPoint: 'current_year',
  })

  const currentValueForDataPoint = digObject(dataForLatestPeriod, 'current_year', 0)

  const positiveChange = percentageChange >= 0

  return (
    <DashboardModule boxProps={{ marginBottom: 0 }} loading={loading} title="Trends">
      <Box flexDirection="column" padding="large">
        <Box alignItems="center" flexDirection="row">
          <Text fontSize="xxxlarge" color="darkGrey" marginRight="medium">
            {currentValueForDataPoint}
          </Text>

          <Text color="green" fontSize="xsmall">
            {percentageChange}%
            <FontAwesomeIcon icon={positiveChange ? faArrowUp : faArrowDown} style={{ marginLeft: '5px' }} />
          </Text>
        </Box>

        <Text color="bodyFontLightColor" fontSize="small" marginTop="medium">
          {description}
        </Text>

        <Box marginTop="large">
          {/*
           // @ts-expect-error TS2786 */}
          <AreaChart
            // @ts-expect-error TS2741
            dataPayload={{
              dataArray: dataArray.slice(-4, -1),
              dataKeys: ['current_year'],
            }}
            chartHeight={50}
            disableLegend
            height={50}
          />
        </Box>
      </Box>
    </DashboardModule>
  )
}

export default StatisticWithGraph
